import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

const footerLinks = [
  {
    title: '热门分类',
    links: categories.slice(0, 5).map((cat) => ({
      label: cat.name,
      href: `/category/${cat.slug}`,
    })),
  },
  {
    title: '推荐阅读',
    links: [
      { label: '本周热门', href: '/category/fantasy' },
      { label: '新作上架', href: '/category/romance' },
      { label: '完结佳作', href: '/category/drama' },
      { label: '读者最爱', href: '/category/action' },
      { label: '编辑推荐', href: '/category/comedy' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌故事', href: '/about' },
      { label: '联系方式', href: '/about' },
      { label: '用户协议', href: '/about' },
      { label: '隐私政策', href: '/about' },
      { label: '帮助中心', href: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 relative overflow-hidden">
      <div className="absolute -left-10 top-10 w-32 h-64 bg-background-200/50 -rotate-12 hidden lg:block"></div>
      <div className="absolute -right-10 bottom-10 w-40 h-56 bg-background-200/50 rotate-12 hidden lg:block"></div>

      <div className="relative z-10 px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="bg-background-50 rounded-2xl px-6 md:px-10 py-10 md:py-12">
            <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
              <div className="lg:w-1/4">
                <div className="flex items-center gap-2 mb-4">
                  <div className="w-9 h-9 flex items-center justify-center">
                    <i className="ri-book-open-line text-2xl text-primary-500"></i>
                  </div>
                  <span className="text-lg font-bold text-foreground-950">韩漫之家</span>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  韩漫之家是国内领先的韩国漫画免费阅读平台，汇集海量优质韩漫资源，为您提供流畅、舒适的在线阅读体验。
                </p>
                <div className="flex items-center gap-3">
                  <a href="#" className="w-9 h-9 flex items-center justify-center bg-background-100 rounded-full text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                    <i className="ri-wechat-line"></i>
                  </a>
                  <a href="#" className="w-9 h-9 flex items-center justify-center bg-background-100 rounded-full text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                    <i className="ri-weibo-line"></i>
                  </a>
                </div>
              </div>

              {footerLinks.map((col) => (
                <div key={col.title} className="lg:w-1/4">
                  <h4 className="text-sm font-semibold text-foreground-950 uppercase tracking-wider mb-4">
                    {col.title}
                  </h4>
                  <ul className="space-y-2.5">
                    {col.links.map((link) => (
                      <li key={link.label}>
                        <Link
                          to={link.href}
                          className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                        >
                          {link.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            <div className="mt-10 pt-6 border-t border-background-200/70">
              <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
                <p className="text-xs text-foreground-500">
                  &copy; 2026 韩漫之家 版权所有 | <span className="mx-1">|</span> 京ICP备2026000000号
                </p>
                <p className="text-xs text-foreground-500">
                  本站所有漫画均来自互联网，仅供学习交流使用
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}